var React = require('react');

function Code (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.4703 21.1313L13.1516 21.3964V20.6653V15.5777V15.2212L12.8146 15.105L8.15682 13.4981L12.8128 11.9123L13.1516 11.7969V11.439V6.40401V5.67446L12.4712 5.9377L0.819592 10.4454L0.5 10.5691V10.9118V16.1312V16.4732L0.818675 16.5972L12.4703 21.1313ZM12.56 25.6591L12.256 26.3585H13.0186H18.159H18.4868L18.6175 26.0578L29.4255 1.19936L29.7296 0.5H28.967H23.8266H23.4988L23.3681 0.800637L12.56 25.6591ZM28.8484 20.6653V21.3949L29.5288 21.1317L41.1804 16.6239L41.5 16.5003V16.1576V10.9381V10.5962L41.1813 10.4722L29.5297 5.93805L28.8484 5.67292V6.40401V11.4917V11.8481L29.1854 11.9644L33.8432 13.5712L29.1872 15.1571L28.8484 15.2725V15.6304V20.6653Z","stroke":"#D22128"}));
}

Code.defaultProps = {"width":"42","height":"27","viewBox":"0 0 42 27","fill":"none"};

module.exports = Code;

Code.default = Code;
